import { i18n } from '@/i18n';
import { GroupActionType, GroupMenuItems } from '../entities/GroupMenu';
import { FilterContentItem } from '@/corePagesModule/filterModal/filterModal';

/**
 * グループメニューのアイテム用のサービス
 */
export class GroupMenuService {
  /**
   * グループメニューのアイテムが新規作成かどうか
   * @param item - グループメニューのアイテム
   */
  static isCreateGroup = (item: GroupMenuItems): boolean => {
    return item === 'CreateGroup';
  };

  /**
   * グループメニューのアイテムが追加かどうか
   * @param item - グループメニューのアイテム
   */
  static isAddBusinessToGroup = (item: GroupMenuItems): boolean => {
    return item === 'AddBusinessToGroup';
  };

  /**
   * グループメニューのアイテムが編集かどうか
   * @param item - グループメニューのアイテム
   */
  static isEditGroup = (item: GroupMenuItems): boolean => {
    return item === 'EditGroup';
  };

  /**
   * グループメニューのアイテムが削除かどうか
   * @param item - グループメニューのアイテム
   */
  static isDeleteGroup = (item: GroupMenuItems): boolean => {
    return item === 'DeleteGroup';
  };

  /**
   * グループメニューのアイテムの表示名を取得する
   * @param item - グループメニューのアイテム
   */
  static getDisplayText = (item: GroupMenuItems): string => {
    const t = i18n.t;
    switch (item) {
      case 'CreateGroup':
        return t('新規作成');
      case 'AddBusinessToGroup':
        return t('取引を追加');
      case 'EditGroup':
        return t('グループを編集');
      case 'DeleteGroup':
        return t('グループを削除');
    }
  };

  /**
   * グループメニューのアイテムのローディング中のテキストを取得する
   * @param item - グループメニューのアイテム
   */
  static getLoadingText = (item: GroupActionType): string => {
    const t = i18n.t;
    switch (item) {
      case 'create':
        return t('グループを作成中です。');
      case 'delete':
        return t('グループを削除中です。');
      case 'updateName':
        return t('グループ名を更新中です。');
      case 'addBusiness':
        return t('集計取引をグループに追加中です。');
      case 'deleteBusiness':
        return t('集計取引をグループから削除中です。');
      default:
        return '';
    }
  };

  /**
   * 操作後にリロードが必要かどうか
   * @param item - グループメニューのアイテム
   */
  static needReloadOnAfterAction = (item: GroupActionType): boolean => {
    return item === 'create' || item === 'delete' || item === 'updateName';
  };

  /**
   * 取引が関係するグループメニューのアイテムかどうか
   * @param item - グループメニューのアイテム
   */
  static isBusinessRelatedItem = (item: GroupMenuItems): boolean => {
    return item === 'AddBusinessToGroup';
  };

  /**
   * FilterContentItemを取得する
   * @param selectedGroupId - 選択されたグループID
   */
  static getFilterContentItem = (selectedGroupId: string): FilterContentItem => {
    const t = i18n.t;
    return {
      filterType: 'GROUP_ID',
      selectedValue: [selectedGroupId],
      label: t('グループ'),
    };
  };
}
